// combatpro/panels/encounter/EncounterSystemState.js
//
// Combat PRO - EncounterSystemState (Stage 65: Encounter View Foundation).
//
// The 2x2 live stat grid inside the "System State" card of view-encounter
// (battletracker.html 3445-3462): #enc-stat-players, #enc-stat-players-hp (green),
// #enc-stat-monsters, #enc-stat-monsters-hp (red). A faithful migration of the
// legacy DOM writes in the system-state block of updateEncounterSummary
// (9427-9432) into a declarative render that re-derives from state.
//
// All math is delegated to the pure encounterEngine (computeSystemStats); this
// component reads CombatContext state and renders. Markup, ids, inline styles, and
// the value colours reproduce the master spec verbatim. The legacy showed raw
// numbers here (0, never "-"). No state owned, nothing mutated, no DOM access, no
// getElementById. No optional chaining. No em dash.

import React, { useContext } from 'react';
import { CombatContext } from '../../contexts/CombatContext';
import { computeSystemStats } from './encounterEngine';

const boxStyle = { background: 'var(--cp-surface-inset)', border: '1px solid var(--cp-border-strong)', borderRadius: '10px', padding: '14px' };
const labelStyle = { fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', color: 'var(--cp-text-muted)', letterSpacing: '0.5px' };

function EncounterSystemState() {
  const { state } = useContext(CombatContext);
  const stats = computeSystemStats(state.players, state.monsters, state.activeMonsterCount || 0);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
      <div style={boxStyle}>
        <div style={labelStyle}>Players</div>
        <div id="enc-stat-players" style={{ fontSize: '24px', fontWeight: 800, color: 'var(--cp-player)' }}>{stats.players}</div>
      </div>
      <div style={boxStyle}>
        <div style={labelStyle}>Players HP</div>
        <div id="enc-stat-players-hp" style={{ fontSize: '24px', fontWeight: 800, color: 'var(--cp-success)' }}>{stats.playersHp}</div>
      </div>
      <div style={boxStyle}>
        <div style={labelStyle}>Monsters</div>
        <div id="enc-stat-monsters" style={{ fontSize: '24px', fontWeight: 800, color: 'var(--cp-monster)' }}>{stats.monsters}</div>
      </div>
      <div style={boxStyle}>
        <div style={labelStyle}>Monsters HP</div>
        <div id="enc-stat-monsters-hp" style={{ fontSize: '24px', fontWeight: 800, color: '#F87171' }}>{stats.monstersHp}</div>
      </div>
    </div>
  );
}

export default EncounterSystemState;
